import {createAsyncThunk} from "@reduxjs/toolkit";
import instance from "../AxiosOrders";


export const getLeaves = createAsyncThunk('leaves/getAll', async (employeeId, {rejectWithValue}) => {
    try {
        const {data} = await instance.get(`/leaves/employee/${employeeId}`);
        return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
});

export const saveLeaves = createAsyncThunk('leaves/save', async (page, { rejectWithValue }) => {
    try {
        const { data } = await instance.post(`/leave`, page, {
            headers: {"Content-type": "application/json"},
        });
        return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
})

